/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DistrictDTO } from './districtDTO';


export interface AslDTO { 
    /**
     * The asl's address
     */
    address?: string;
    /**
     * The asl's code
     */
    code?: string;
    /**
     * The asl's creation date
     */
    createDate?: Date;
    /**
     * The create user's uuid
     */
    createUserUuid?: string;
    /**
     * The asl's descriprion
     */
    description?: string;
    /**
     * The asl's districts
     */
    districts: Array<DistrictDTO>;
    /**
     * The asl's operative end date
     */
    endDate?: Date;
    /**
     * The asl's obsolete
     */
    obsolete?: boolean;
    /**
     * The asl's operative start date
     */
    startDate?: Date;
    /**
     * The asl's telephone
     */
    tel?: string;
    /**
     * The asl's update date
     */
    updateDate?: Date;
    /**
     * The update user's uuid
     */
    updateUserUuid?: string;
    /**
     * The asl's uuid
     */
    uuid?: string;
}
